<template>
  <div>
    <div v-if="value">
      <div style="display: flex; align-items: center">
        <div>
          <md-icon
            class="md-primary"
            :style="{
              ['background-color']: value.cor,
              ['border-radius']: '2px',
              ['min-height']: '2vh',
              ['min-width']: '2vh',
            }"
          />
        </div>
        <div>
          <md-button
            class="md-primary md-raised"
            :disabled="editable || enviando"
            @click.prevent="dialogActive = true"
          >
            {{ value.equipamentoNome + ' - ' + value.nomeExibicao }}
          </md-button>
        </div>
      </div>
    </div>
    <div v-else>
      <md-progress-spinner
        :md-diameter="50"
        :md-stroke="5"
        md-mode="indeterminate"
      />
    </div>

    <md-dialog
      :md-active.sync="dialogActive"
      :md-click-outside-to-close="!enviando"
      :md-close-on-esc="!enviando"
    >
      <md-dialog-title>Tem certeza?</md-dialog-title>
      <md-dialog-content>
        Essa ação irá demorar de 1 a 5 minutos para ser executada, poderá ser
        cancelado antes.
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="enviando" @click="dialogActive = false">
          cancelar
        </md-button>
        <md-button
          class="md-primary"
          :disabled="enviando"
          @click="prepareToSend()"
        >
          enviar
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="parametroDialogForm"
      :md-click-outside-to-close="!enviando"
      :md-close-on-esc="!enviando"
    >
      <md-dialog-title>Parâmetro</md-dialog-title>

      <div class="p-5" style="text-align: center">
        <p class="md-subheading">
          Valor entre 0 a {{ value && (value.xMAX || 0) }}
        </p>
        <md-field>
          <label for="parametroToSend">Valor</label>
          <md-input
            id="parametroToSend"
            v-model.number="parametroToSend"
            type="number"
            name="parametroToSend"
          />
        </md-field>
      </div>

      <md-dialog-actions>
        <md-button
          class="md-accent"
          :disabled="enviando"
          @click="parametroDialogForm = false"
        >
          Cancelar
        </md-button>
        <md-button
          class="md-primary"
          :disabled="enviando"
          @click="() => sendAcaoParametrizada()"
        >
          Enviar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { EventBus, Topics, Types } from '@/event-bus'
import { AcaoTipo } from '@/utils/constants'

import http from '../../../utils/http'

export default {
  name: 'ViewShowAction',
  props: {
    componente: {
      type: Object,
      required: true,
    },
    // No editor (moveable) o clique serve para selecionar/arrastar; desabilita o
    // botao para nao disparar o envio da acao durante a edicao.
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: null,
      dialogActive: false,
      parametroDialogForm: false,
      parametroToSend: null,
      enviando: false,
    }
  },
  async beforeMount() {
    this.value = await http.get(
      'local/acao/botoes/' + this.componente.value.botaoAcaoEquipamentoId
    )
  },
  methods: {
    prepareToSend() {
      const { xMAX, yMAX } = this.value

      if (xMAX !== null && yMAX !== null) {
        this.dialogActive = false
        this.parametroDialogForm = true
        return
      }

      this.enviarAcao()
    },
    async sendAcaoParametrizada() {
      if (this.parametroToSend === null || this.parametroToSend === '') {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Valor inválido',
          type: Types.WARNING,
        })
        return
      }

      if (this.parametroToSend < 0 || this.parametroToSend > this.value.xMAX) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Valor menor que 0 ou maior que o permitido',
          type: Types.WARNING,
        })
        return
      }

      await this.enviarAcao()
    },
    async enviarAcao() {
      if (this.enviando) return

      this.enviando = true

      try {
        const response = await http.post(
          `equipamento/acao`,
          {
            equipamentoId: this.value.equipamentoId,
            botaoAcaoId: this.componente.value.botaoAcaoEquipamentoId,
            acaoTipo: AcaoTipo.comandoBasico,
            valorParametrizado: this.parametroToSend,
          },
          false
        )

        if (response) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Ação enviada com sucesso!',
            type: Types.INFO,
          })
        } else {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Erro ao enviar ação',
            type: Types.DANGER,
          })
        }
      } finally {
        this.enviando = false
        this.dialogActive = false
        this.parametroDialogForm = false
      }
    },
  },
}
</script>

<style scoped></style>
